module.exports = __webpack_public_path__ + "static/img/chanpin.c45a7c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanpin.jpg
// module id = Na5q
// module chunks = 1